/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import {
  AsyncPropSelector,
  ApiProgressLoader,
  getPositiveValue,
  CurrencyText,
  CurrencyField
} from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import {
  Button,
  Popover,
  TextField,
  ButtonGroup,
  PositiveNumberField
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { Edit } from '@styled-icons/material/Edit';
import React, { Fragment, useCallback, useState, createElement } from 'react';
import styled from 'styled-components';
import { EditIcon } from '@nile/components/src/Icons';
import { clamp } from 'lodash';
import {
  DISCOUNT_TYPE,
  MAX_DECIMAL_DIGITS_IN_DISCOUNT
} from '@nile/client_management/src/Pages/Invoice/constants';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  padding-left: 8px;
  padding-right: 8px;
  max-width: 100%;
  white-space: break-spaces;
  .Superops-TextField__ActionableSuffix {
    background: ${(props) =>
      props.clicked ? '#fffae4' : 'rgba(0, 0, 0, 0.05)'} !important;
    border-radius: 10px 10px 0 0;
    transition: background 200ms linear;
  }
`;

function TextCell(props) {
  const { cell, params, _ticket } = props;
  const allProps = params || cell.column;
  const { editable, field, actions, accessor, entity, editMode } = allProps;
  const ticket = _ticket || cell.row.original;
  const [popoverActive, setPopoverActive] = useState(false);
  const [updatedProperties, setUpdatedProperties] = useState({});
  const [clicked, setClicked] = useState(false);
  const [apiProgress, setApiProgress] = useState(false);
  const [apiResult, setApiResult] = useState('');
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });
  const activator = <EditIcon onClick={() => togglePopoverActive()} />;

  const isDiscountPercent =
    cell.row.original.discountType === DISCOUNT_TYPE.PERCENT;

  const updateSelectedProperties = (key, value) => {
    setUpdatedProperties({
      ...updatedProperties,
      [key]: value
    });
  };

  const updateSelection = (f, val) => {
    let serialisedValue = null;
    if (field.isCustom) {
      updateSelectedProperties('customFields', val);
    } else {
      switch (field.name) {
        case 'techGroup':
          serialisedValue = { groupId: val.groupId, name: val.name };
          break;
        case 'technician':
          serialisedValue = { userId: val.userId };
          break;
        case 'sop':
          serialisedValue = { sopId: val.sopId, name: val.name };
          break;
        default:
          serialisedValue = val.name;
      }
      updateSelectedProperties(field.name, serialisedValue);
    }
  };

  const setApiComplete = (state) => {
    if (props.showProgress) {
      setApiProgress(false);
      setApiResult(state);
    }
    setTimeout(() => {
      setApiResult('');
    }, 2000);
  };

  const getTag = () => {
    const fieldValue = updatedProperties[field.name] || ticket[field.name];
    const defaultValue = fieldValue
      ? typeof fieldValue === 'object'
        ? {
            name: fieldValue.name,
            label: fieldValue.name,
            value: fieldValue.name
          }
        : { name: fieldValue, label: fieldValue, value: fieldValue }
      : '';
    return (
      <div className="min-w-200 max-w-250 fg1 pr10 pl10 mt-8 mb8 ">
        <AsyncPropSelector
          defaultValue={defaultValue}
          updateSelection={updateSelection}
          ticket={ticket}
          field={field}
          entity={entity || 'Ticket'}
        />
        <div className="mt10">
          <ButtonGroup>
            <Button
              onClick={() => {
                togglePopoverActive();
                setUpdatedProperties({});
              }}
            >
              Cancel
            </Button>
            <Button
              primary
              onClick={() => {
                if (props.showProgress) {
                  setApiProgress(true);
                }
                actions.save &&
                  actions.save(
                    updatedProperties,
                    ticket,
                    props.data,
                    setApiComplete
                  );
                togglePopoverActive();
                setUpdatedProperties({});
              }}
            >
              Save
            </Button>
          </ButtonGroup>
        </div>
      </div>
    );
  };

  const renderValue = (displayVal, suffix, data) => {
    let updatedDisplayVal = `${displayVal}${suffix || ''}`;
    if (field?.name === 'requester' && ticket?.source === 'Agent') {
      return 'System';
    }

    if (allProps.id === 'discountRate') {
      if (data.discountType === DISCOUNT_TYPE.AMOUNT) {
        updatedDisplayVal = <CurrencyText value={data.discountAmount} />;
      } else {
        updatedDisplayVal = `${data.discountRate}%`;
      }
    }

    return createElement(
      cell?.column?.isBold ? 'b' : Fragment,
      {},
      updatedDisplayVal
    );
  };
  //TODO :: render value in a proper way for NA - vignesh
  let displayVal = cell
    ? props.column.subAccessor
      ? cell.value[props.column.subAccessor]
      : cell.value
      ? cell.value.name || cell.value
      : ''
    : ticket[accessor]
    ? typeof ticket[accessor] === 'object'
      ? ticket[accessor].name
        ? ticket[accessor].name
        : ticket[accessor].firstName
        ? ticket[accessor].firstName + ' ' + ticket[accessor].lastName
        : ticket[accessor].label
      : ticket[accessor]
    : '';

  const renderEditField = () => {
    if (allProps.id === 'discountRate') {
      const Comp = !isDiscountPercent ? CurrencyField : TextField;
      return (
        <Comp
          autoComplete="off"
          type="number"
          min={0}
          suffix={
            <div
              className="flex center pointer br-5 h-30"
              clicked={clicked}
              onClick={() => {
                setClicked(true);
                actions.onChange({
                  key: allProps.id,
                  /* Toggle between amount/percent */
                  itemProperties: isDiscountPercent
                    ? {
                        discountAmount: cell.row.original.discountAmount || '0',
                        discountRate: null,
                        discountType: DISCOUNT_TYPE.AMOUNT
                      }
                    : {
                        discountRate: String(
                          clamp(
                            Number(cell.row.original.discountRate || '0'),
                            0,
                            100
                          )
                        ),
                        discountAmount: null,
                        discountType: DISCOUNT_TYPE.PERCENT
                      },
                  field: cell.row.original
                });

                setTimeout(() => {
                  setClicked(false);
                }, 200);
              }}
            >
              <div className="flex center">
                <div>{isDiscountPercent ? 'percent' : 'amount'}</div>
                <div className="ml4">
                  <SVGIcon name="ArrowDown" />
                </div>
              </div>
            </div>
          }
          onChange={(changedVal) => {
            const val = getPositiveValue(changedVal);
            const [, digitsAfterDecimal] = val.split('.');
            if (
              digitsAfterDecimal?.length ===
              MAX_DECIMAL_DIGITS_IN_DISCOUNT + 1
            ) {
              return;
            }
            const amount =
              Number(cell.row.original?.quantity) *
              Number(cell.row.original?.unitPrice);
            actions.onChange({
              key: allProps.id,
              itemProperties: isDiscountPercent
                ? {
                    discountRate: Number(val) > 100 ? '100' : val,
                    discountAmount: null,
                    discountType: DISCOUNT_TYPE.PERCENT
                  }
                : {
                    discountRate: null,
                    discountAmount:
                      Number(val) > amount ? String(amount) : val || '',
                    discountType: DISCOUNT_TYPE.AMOUNT
                  },
              field: cell.row.original
            });
          }}
          value={
            (isDiscountPercent
              ? cell.row.original.discountRate
              : cell.row.original.discountAmount) ?? '0'
          }
        />
      );
    }
    return (
      <PositiveNumberField
        id="ticketStatusDescription"
        value={displayVal}
        onChange={(val) => {
          const value = getPositiveValue(val);
          actions.onChange({
            key: allProps.id,
            value:
              allProps.id === 'discountRate'
                ? Number(value) > 100
                  ? '100'
                  : value
                : value,
            field: cell.row.original
          });
        }}
        type="number"
      />
    );
  };

  return (
    <Wrap className="cell" clicked={clicked}>
      {editable && editMode ? (
        renderEditField()
      ) : (
        <div title={displayVal}>
          {displayVal ? (
            renderValue(displayVal, cell?.column?.suffix, cell.row.original)
          ) : (
            <DisabledTag>NA</DisabledTag>
          )}
        </div>
      )}
    </Wrap>
  );
}

export default TextCell;
